import { commonConstants, paymentConstants } from '../_constants';
export function branches(state = {}, action) {
  switch (action.type) {
    case commonConstants.GET_ORG_BRANCH_REQUEST:
      return {
        ...state,
        branches: false,
        data: action.branches.data,
      };
    case commonConstants.GET_ORG_BRANCH_SUCCESS:
      return {
        ...state,
        branches: true,
        data: action.branches.data.response,
      };
    case commonConstants.GET_RATE_CHARGE_FAILURE:
      return {
        ...state,
        branches: false,
        data: action.branches.data,
      };
    default:
      return state;
  }
}

export function country(state = {}, action) {
  switch (action.type) {
    case commonConstants.COUNTRY_REQUEST:
      return {
        ...state,
        country: true,
        data: action,
      };
    case commonConstants.COUNTRY_SUCCESS:
      return {
        ...state,
        country: true,
        data: action.country.data.response,
      };
    case commonConstants.COUNTRY_FAILURE:
      return {
        ...state,
        country: false,
        data: action,
      };
    default:
      return state;
  }
}

export function getRemitCurrency(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_REMIT_CURRENCY_REQUEST:
      return {
        ...state,
        remitCurrency: true,
        data: action.remitCurrency.data,
      };
    case paymentConstants.GET_REMIT_CURRENCY_SUCCESS:
      return {
        ...state,
        remitCurrency: true,
        data: action.remitCurrency.data.response,
      };
    case paymentConstants.GET_REMIT_CURRENCY_FAILURE:
      return {
        ...state,
        remitCurrency: false,
        data: action.remitCurrency,
      };
    case paymentConstants.CLEAR_BENEF_VALUES:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}
export function getRemitCountry(state = {}, action) {
  switch (action.type) {
    case paymentConstants.GET_REMIT_COUNTRY_REQUEST:
      return {
        ...state,
        remitCountry: true,
        data: action.remitCountry.data,
      };
    case paymentConstants.GET_REMIT_COUNTRY_SUCCESS:
      return {
        ...state,
        remitCountry: true,
        data: action.remitCountry.data.response,
      };
    case paymentConstants.GET_REMIT_COUNTRY_FAILURE:
      return {
        ...state,
        remitCountry: false,
        data: action.remitCountry,
      };
    default:
      return state;
  }
}
